export default __webpack_public_path__ + "static/media/SourceSansPro-BlackItalic.eb8408e3.ttf";